import { render } from "./ArticleFormModal.vue?vue&type=template&id=9aa02568&scoped=true"
import script from "./ArticleFormModal.vue?vue&type=script&lang=js"
export * from "./ArticleFormModal.vue?vue&type=script&lang=js"

import "./ArticleFormModal.vue?vue&type=style&index=0&id=9aa02568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa02568"]])

export default __exports__